import Vue from 'vue';
import VueRouter from 'vue-router';
import { supportedLocales, setLocale } from '@/locales';
import i18n from '@/locales';
import { getLayoutChildren } from './tree';

Vue.use(VueRouter);

const routes = [
	{
		// 原先客户网站的根节点会指向英文，功能对齐

		path: '/', // '', '/' -> '/en'
		redirect: `/en`
	},

	// 针对历史书签做重定向优化
	{
		path: '/zh-hans',
		redirect: '/zh-CN'
	},
	{
		path: '/zh-hans/*',
		redirect: '/zh-CN'
	},
	{
		path: '/zh-hant',
		redirect: '/zh-HK'
	},
	{
		path: '/zh-hant/*',
		redirect: '/zh-HK'
	},

	{
		path: '/:locale(zh-CN|zh-HK|en)',
		component: () => import('@/Layout.vue'),
		children: [
			...getLayoutChildren(),
			{
				path: '*',
				// 重定向到父级路径（即当前语言首页）
				redirect: to => {
					return `/${to.params.locale}`;
				}
			}
		]
	},

	{
		path: '*',
		// 当访问到不存在的路由时，直接重定向到首页，而非 404 页面
		redirect: '/'
	}
];

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

// 全局处理 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch(error => {
		if (VueRouter.isNavigationFailure(error)) {
			// resolve error
			return error;
		}
		// throw error
		return Promise.reject(error);
	});
};
// 同样处理 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalReplace.call(this, location, onResolve, onReject);
	}
	return originalReplace.call(this, location).catch(error => {
		if (VueRouter.isNavigationFailure(error)) {
			// resolve error
			return error;
		}
		// throw error
		return Promise.reject(error);
	});
};

router.beforeEach((to, from, next) => {
	console.log('路由跳转：', from.path, ' -> ', to.path);

	const locale = to.params.locale;
	if (locale && supportedLocales.includes(locale)) {
		// 确保页面语言与 URL 中的 locale 一致
		if (i18n.locale !== locale) {
			setLocale(locale);
		}
	}

	// 设置页面标题
	if (to.meta) {
		const { titleKey, title } = to.meta;
		let pageTitle;

		if (titleKey) {
			pageTitle = i18n.t(titleKey);
		} else if (title) {
			pageTitle = title;
		}

		if (pageTitle) {
			document.title = pageTitle;
		}
	}

	next();
});

export default router;
